import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './component.scss'

const ROOT_SELECTOR = '.js-clientSearchByPrefecture-root'
const REGION_LIST_SELECTOR = '.js-clientSearchByPrefecture-regionList'
const REGION_BUTTON_SELECTOR = '.js-clientSearchByPrefecture-region'
const PREFECTURE_MENU_SELECTOR = '.js-clientSearchByPrefecture-prefectureMenu'
const BACK_BUTTON_SELECTOR = '.js-clientSearchByPrefecture-back'
const PREFECTURES_BY_REGION_SELECTOR = '.js-clientSearchByPrefecture-prefecturesByRegion'

const PREFECTURE_MENU_ACTIVE_CLASS = 'client-search-by-prefecture__prefecture-menu--active'
const PREFECTURES_BY_REGION_HIDE_CLASS = 'client-search-by-prefecture__prefectures-by-region--hide'

const showPrefecturesByRegion = (regionId) => {
  const $root = $(ROOT_SELECTOR)
  const $prefectureMenu = $root.find(PREFECTURE_MENU_SELECTOR)
  const $prefecturesByRegion = $root.find(`${PREFECTURES_BY_REGION_SELECTOR}[data-region-id="${regionId}"]`)
  const $regionList = $root.find(REGION_LIST_SELECTOR)

  $prefectureMenu.addClass(PREFECTURE_MENU_ACTIVE_CLASS)
  $prefecturesByRegion.removeClass(PREFECTURES_BY_REGION_HIDE_CLASS)
  $regionList.hide()
}

const closePrefectures = () => {
  const $root = $(ROOT_SELECTOR)
  const $prefectureMenu = $root.find(PREFECTURE_MENU_SELECTOR)
  const $prefecturesByRegion = $root.find(PREFECTURES_BY_REGION_SELECTOR)
  const $regionList = $root.find(REGION_LIST_SELECTOR)

  $prefectureMenu.removeClass(PREFECTURE_MENU_ACTIVE_CLASS)
  $prefecturesByRegion.addClass(PREFECTURES_BY_REGION_HIDE_CLASS)
  $regionList.show()
}

$(() => {
  const $root = $(ROOT_SELECTOR)
  const $regionButton = $root.find(REGION_BUTTON_SELECTOR)
  const $backButton = $root.find(BACK_BUTTON_SELECTOR)

  $regionButton.on('click', (e) => {
    const regionId = $(e.currentTarget).data('region-id')
    showPrefecturesByRegion(regionId)
  })

  $backButton.on('click', () => {
    closePrefectures()
  })
})
